<template>
	<div class="app flex-row align-items-center">
		<div class="container-fluid">
            <div class="client-app-inc" style="height:200px" v-if="loading">
                <Loader></Loader>
            </div>
			<slot v-if="!loading">
                <div v-if="is_script" v-html-js="{html: game_data, script:'javascript'}"></div>
                <iframe v-if="!is_script" :src="game_url" style="height:1000px" frameborder="0" width="100%"/>
            </slot>
		</div>
	</div>
</template>

<style lang="scss">
    #pragmaticSportsIframeContainer iframe{
        min-height: 1000px;    
    }
    #app.mobile div#pragmaticSportsIframeContainer {
        top: 55px;
        height: calc(100% - 118px);
        position: fixed;
        width: 100%;
        iframe{
            min-height: auto  !important;
        }
    }
    #app.sportsbook,
    #app.live{
        footer{
            display: none !important;
        }
    }
    #app.mobile.live,
    #app.mobile.sportsbook{
        position: fixed!important;
        top: 0;
        height: 100%;
        left: 0;
        width: 100%;
        overflow: hidden;
    } 
    #app.mobile.sportsbook, 
    #app.mobile.live{
        .inc{
            padding: 0px !important;
        }
        .mobile-bottom-bar{
           display: none;
        }
        .mobile-bottom-bar.sportsbook{
            display: flex !important;
        }
    }
</style>
<script>
    export default {
        name: 'Live',
        metaInfo () {
            return {
                meta: [
                { 'http-equiv':'Content-Security-Policy', content: "upgrade-insecure-requests" },
                ]
            }
        },
        data() {
            return {
                loading: true,
                game_url: null,
                game_data: null,
                is_script: false,
                iframeContainer: null,
                iframe:null,
                auth : {},
            }
        },
        created () {
            this.fetchData();
            if(this.isMobile){
                document.querySelector("body").style.setProperty('--mobileHeight', window.innerHeight + 'px');
            }
        },
        watch:{
            loggedIn(val,oldVal){
                if(!val){
                    /*var message = {
                        "command": "EXT.PPBET_SB.USER_LOGOUT",
                        "parameters": {
                            name: nav,
                            toggle: toggle
                        }
                    };
                    let iframe = window.document.querySelector('#pragmaticSportsIframe');
                    iframe.contentWindow.postMessage(message, '*');*/
                }
            }
        },
        mounted () {
            this.addHandler();
        },
        destroyed() {
            this.removeHandler();
        },
        methods: {
            fetchData() {
                this.loading = true;
                axios.get('/sportsbook')
                .then((response)=>{

                    this.loading = false;
                    this.is_script = response.data.config.is_script
                    this.auth = response.data.auth;

                    if(this.is_script)
                    {
                        this.game_data = response.data.data
                    }
                    else
                    {
                        this.game_url = response.data.config.url
                    }   
                })
                .catch((err)=>{
                });

            },
            toNav(nav) {
                var message = {
                    "command": "SB.PPBET_SB.DEEPLINK",
                    "parameters": {
                        name: nav,
                        type:'page',
                        sportID:""
                    }
                };
                let iframe = window.document.querySelector('#pragmaticSportsIframe');
                iframe.contentWindow.postMessage(message, '*');
            },
            triggerComponent(nav, toggle) {
                var message = {
                    "command": "SB.PPBET_SB.DEEPLINK",
                    "parameters": {
                        name: nav,
                        toggle: toggle
                    }
                };
                let iframe = window.document.querySelector('#pragmaticSportsIframe');
                iframe.contentWindow.postMessage(message, '*');
            },
            addHandler() {
                window.addEventListener('message', this.eventListener);
            },
            removeHandler(){
                window.removeEventListener('message', this.eventListener);
            },
            eventListener(event)
            {
                if(process.env.NODE_ENV == 'development')
                {
                    if(event.origin == 'http://localhost:8080')
                    {
                        return false;
                    }
                }

                var data = JSON.parse(event.data);
                if(data.command == "EXT.PPBET_SB.UPDATE_SIZE"){
                    let calcHeight = data.parameters.height;
                    let iframeContainer = document.getElementById("pragmaticSportsIframeContainer");
                    iframeContainer.style.height = calcHeight + 'px';
                }

                if(data.command == 'EXT.PPBET_SB.SB_READY')
                {
                    this.setAuthToken();
                    this.setUserBalance();
                    this.setUserLanguage();
                    this.triggerComponent('MYBETS', 'open')
                }
            },
            setAuthToken()
            {
                var message = {
                    "command": "SB.PPBET_SB.SET_AUTH_TOKEN",
                    "parameters": {
                        "authtoken": this.auth.token,
                        "tokenExpiry" : this.auth.expiry,
                        "currency": this.auth.currency,
                        "currencySymbol": this.auth.currencySymbol,
                        "playerId": this.auth.playerId
                    }
                };


                const iframe = window.document.querySelector('#pragmaticSportsIframe');
                iframe.contentWindow.postMessage(message, '*');
                console.log('User Set Auth Token! : ' + this.auth.token);
            },
            setUserBalance(balance = 0)
            {
                var message = {
                    "command": "SB.PPBET_SB.GET_BALANCE",
                    "parameters": {
                        "balance": parseFloat(this.user.balance),
                    }
                };

                const iframe = window.document.querySelector('#pragmaticSportsIframe');
                iframe.contentWindow.postMessage(message, '*');

                console.log('User Set Balance! : ' + parseFloat(this.user.balance));
            },
            setUserLanguage(language)
            {
                var message = {
                    "command": "SB.PPBET_SB.SET_LANGUAGE",
                    "parameters": {
                        "language": this.$i18n.locale,
                    }
                };

                const iframe = window.document.querySelector('#pragmaticSportsIframe');
                iframe.contentWindow.postMessage(message, '*');

                console.log('User Set Language! : ' + this.$i18n.locale);
            }
        },
        computed:
        {
            user()
            {
                return this.$user();
            },
            loggedIn() {
                return this.$store.getters['auth/isLoggedIn']
            },
        }
    }
</script>